/**
 * Component Entry
 *
 */

import AriaLive from './AriaLive'
export default AriaLive
export * from './AriaLive'
